import { render, staticRenderFns } from "./BlankSlate.vue?vue&type=template&id=7dc7fc7a&scoped=true&"
import script from "./BlankSlate.js?vue&type=script&lang=js&"
export * from "./BlankSlate.js?vue&type=script&lang=js&"
import style0 from "./BlankSlate.scss?vue&type=style&index=0&id=7dc7fc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc7fc7a",
  null
  
)

export default component.exports